import { useI18n } from 'vue-i18n'
import { BikeCategory, BikeHoodsType } from '@/types/bike'

export const getBikeCategory = (
  mainBikeType: string | undefined,
  subBikeType: string | undefined,
): BikeCategory => {
  switch (mainBikeType?.toLowerCase()) {
    case 'mbkroad':
      return BikeCategory.ROAD

    case 'mbkcg':
      switch (subBikeType?.toLowerCase()) {
        case 'sbkcoc':
          return BikeCategory.CYCLOCROSS

        case 'sbkcgr':
          return BikeCategory.GRAVEL

        default:
          return BikeCategory.GRAVEL
      }

    case 'mbkmtb':
      return BikeCategory.MTBCROSSCOUNTRY

    case 'mbkmtbtrail':
      return BikeCategory.MTBTRAIL

    case 'mbktime':
      return BikeCategory.TIMETRIAL

    case 'mbktri':
      switch (subBikeType?.toLowerCase()) {
        case 'sbksd':
          return BikeCategory.SHORTTRIATHLON

        case 'sbkld':
          return BikeCategory.FULLTRIATHLON

        default:
          return BikeCategory.SHORTTRIATHLON
      }

    case 'mkbcitybike':
      return BikeCategory.CITY

    case 'mbktourtrek':
      return BikeCategory.TREKKING

    case 'mbkebike':
      switch (subBikeType?.toLowerCase()) {
        case 'sbkroad':
          return BikeCategory.ROADELECTRIC

        case 'sbkmtb':
          return BikeCategory.MTBELECTRIC

        case 'sbkcity':
          return BikeCategory.CITYELECTRIC

        case 'sbktouring':
          return BikeCategory.TREKKINGELECTRIC

        default:
          return BikeCategory.ROADELECTRIC
      }

    default:
      return BikeCategory.ROAD
  }
}

export const getHoodsTypeFromCategory = (
  category: BikeCategory,
): BikeHoodsType => {
  switch (category) {
    case BikeCategory.ROAD:
    case BikeCategory.ROADELECTRIC:
    case BikeCategory.SHORTTRIATHLON:
    case BikeCategory.GRAVEL:
    case BikeCategory.GRAVELELECTRIC:
    case BikeCategory.CYCLOCROSS:
      return BikeHoodsType.DROPBAR

    case BikeCategory.MTBTRAIL:
    case BikeCategory.MTBCROSSCOUNTRY:
    case BikeCategory.MTBELECTRIC:
    case BikeCategory.CITY:
    case BikeCategory.CITYELECTRIC:
    case BikeCategory.TREKKING:
    case BikeCategory.TREKKINGELECTRIC:
      return BikeHoodsType.FLATBAR

    case BikeCategory.TIMETRIAL:
    case BikeCategory.FULLTRIATHLON:
      return BikeHoodsType.TRIBAR

    default:
      return BikeHoodsType.DROPBAR
  }
}

export const getHoodsTerm = (hoodsType: BikeHoodsType) => {
  const { t } = useI18n()

  switch (hoodsType) {
    case BikeHoodsType.DROPBAR:
      return t('common.bike.hoodsTypes.hoods')

    case BikeHoodsType.FLATBAR:
      return t('common.bike.hoodsTypes.grips')

    case BikeHoodsType.TRIBAR:
      return t('common.bike.hoodsTypes.pads')

    default:
      return t('common.bike.hoodsTypes.hoods')
  }
}

export const getHoodsType = (filter: number) => {
  switch (filter) {
    case 1:
      return BikeHoodsType.DROPBAR

    case 100:
      return BikeHoodsType.FLATBAR

    case 200:
      return BikeHoodsType.FLATBAR

    case 221:
      return BikeHoodsType.DROPBAR

    case 300:
      return BikeHoodsType.TRIBAR

    default:
      return BikeHoodsType.DROPBAR
  }
}

export const arrayEquals = (a: any[], b: any[]) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  )
}

export const sleep = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms))
